// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2HibW","insightsList":"newBusinessInsightsMenu_insightsList__A8ot7","active":"newBusinessInsightsMenu_active__1VLx2"};